// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"a2404187","162":"db02265f","258":"66c5be1d","471":"db02265f","674":"30c672be"}[chunkId] + ".chunk.css";
};